export enum TermsType {
  Ticket = 1,
  Foom = 2,
}
